<section class="content">
  <div class="card" style="padding:25px">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col" style="text-align: right;">
        <button mat-button
          (click)="deleteClicked()" class="button-class">Delete Complete Sale</button>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <label for="exampleFormControlFile1">Grn Excel<i class="material-icons"
            style="color: red;font-size: 14px;">star</i></label>
        <input type="file" class="form-control-file" id="exampleFormControlFile1"
          (change)="convertExcelToBase64ForGrn($event)" style="font-size: 20px"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
      </div>
      <div class="col-6">
        <label for="exampleFormControlFile1">Product Excel<i class="material-icons"
            style="color: red;font-size: 14px;">star</i></label>
        <input type="file" class="form-control-file" id="exampleFormControlFile2"
          (change)="convertExcelToBase64ForProduct($event)" style="font-size: 20px"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
      </div>
    </div>
    <br>
    <div class="row">
      <div *ngIf="!is_document_available" class="col-2">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="60">
        </mat-progress-spinner>
      </div>
      <div class="col" style="text-align: center;">
        <button mat-button [disabled]="grn_excel_file == null || product_excel_file == null"
          (click)="uploadClicked()" class="button-class">Upload</button>
      </div>
    </div>
  </div>
</section>
